
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class FetchDigitalMailboxService {
   private eventListeners = new BehaviorSubject<any | null>(null);

   fetch (): Observable<any | null> {
      this.eventListeners = new BehaviorSubject<any>(null);
      return this.eventListeners.asObservable();
   };

   publish(event: any): void {
      this.eventListeners.next(event);
    }
}